import cnames from 'classnames'
import storeConnect from 'Checkout/Redux/Connect'
import InfoTripInsurance from 'Checkout/Components/Shared/InfoTripInsurance'
import ReservationDetailItem from 'Shared/ReservationDetailItem'
import Reservations from 'Checkout/Components/Shared/CartSummary/Reservations'
import TaxDetails from 'Shared/TaxDetails'
import TotalRow from 'Checkout/Components/Shared/TotalRow'

const ReservationConfirmationInfo = ({ className, isGroup, loading, tripInsuranceSupportPhone, reservation,
                                       reservations }) => {
  const { balance, balanceDue, balanceGroupingRemaining, balanceGroupingTotal, balancePaid, balanceRemaining,
          balanceTotal, customFieldValues, data, hasBalance, hasTripInsurance, isParent, marketplace, pricing,
          purchase, tripInsurancePolicy, tripInsurancePrice } = reservation
  const { isTaxIncluded, taxConfig } = pricing
  const { special_request: specialRequest } = data
  const containerClasses = cnames('reservation-details--information', className)
  const feeLabel = marketplace ? 'Service Fee' : 'Platform Fee'
  const itemNameClass = 'text-gray'
  const groupPricingNeeded = isParent && balanceGroupingRemaining?.amount > 0
  const remaining = groupPricingNeeded ? balanceGroupingRemaining : balanceRemaining
  const total = groupPricingNeeded ? balanceGroupingTotal : balanceTotal
  const totals = groupPricingNeeded ? purchase : pricing
  const tripProtectionPrice = tripInsurancePolicy ? tripInsurancePolicy.grossPremium : tripInsurancePrice
  const reservationList = isGroup ? reservations : [reservation]
  const valueClass = 'text-gray-800'

  return (
    <div>
      <div className={containerClasses}>
        {!loading && (
          <Reservations isCollapseOpen reservations={reservationList} reservationWrapperClasses="mb-4"
                        showDivider={false} />
        )}

        <ReservationDetailItem containerClass="mt-4" hideColon itemName="Subtotal" itemNameClass={itemNameClass}
                               value={totals.subtotal?.display} valueClass={valueClass} />

        {!isTaxIncluded && (
          <ReservationDetailItem hideColon itemName="Tax" itemNameClass={itemNameClass} value={totals.tax}
                                 valueClass={valueClass} />
        )}

        {totals.camperProcessingFee?.amount > 0 && (
          <ReservationDetailItem hideColon itemName="Processing Fee" itemNameClass={itemNameClass}
                                 value={totals.camperProcessingFee} valueClass={valueClass} />
        )}

        <ReservationDetailItem hideColon itemName={feeLabel} itemNameClass={itemNameClass}
                               value={totals.camperFee?.display} valueClass={valueClass} />

        {hasTripInsurance && (
          <ReservationDetailItem hideColon itemName="Trip Insurance" itemNameClass={itemNameClass}
                                 value={tripProtectionPrice.display} valueClass={valueClass} />
        )}

        <TotalRow {...{ balancePaid, balanceDue, hasBalance, isGroup, itemNameClass, pricing, valueClass }}
                  balanceRefunded={balance?.refunded} balanceRemaining={remaining} balanceTotal={total} />

        {isTaxIncluded && (
          <TaxDetails className="mb-3 mb-md-4" nameClass="fw-bold" tax={totals.tax} taxName={taxConfig?.taxName}
                      titleClass="text-gray" />
        )}

        {totals.nonRefundableAmount?.amount > 0 && (
          <>
            <hr />

            <p>
              <small className="text-muted fst-italic">
                {totals.nonRefundableAmount?.display} of this reservation is non-refundable per the RoverPass
                Cancellation policy. Check the campground cancellation policy for any other non-refundable amounts.
              </small>
            </p>
          </>
        )}
      </div>

      <hr />

      {specialRequest && (
        <div>
          <h5 className="fw-bold mb-3">Special Requests</h5>
          <p className="text-gray mt-3">{specialRequest}</p>
        </div>
      )}

      {hasTripInsurance && (
        <div className="mt-4">
          <h5 className="fw-bold mb-3">Trip Protection Information</h5>

          <p className="fw-bold">Policy Number: { tripInsurancePolicy?.number || 'Processing...' }</p>

          <p>
            This policy covers any expenses charged at the time of booking the reservation. If any modifications
            are made to this reservation, reach out to Generali at {` ${tripInsuranceSupportPhone}`} to ensure any
            additional charges made for modifications on this reservation are included in your coverage
          </p>

          <InfoTripInsurance className="mt-1" showFirstParagraph={false}
                             termsAndConditionsClass="text-muted fst-italic" />
        </div>
      )}

      {!!customFieldValues.length && (
        <div className="mb-4">
          <h5 className="fw-bold mb-3">More Information</h5>
          {customFieldValues.map(({ question, answer }) => {
            const fetchAnswer = typeof answer === 'object' ? answer.join(', ') : answer

            return (
              <div className="mb-2" key={question}>
                <ReservationDetailItem hideColon itemName={question} itemNameClass={itemNameClass}
                                       value={fetchAnswer} valueClass={valueClass} />
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}

const mapStateToProps = state => ({
  tripInsuranceSupportPhone: state.options.tripInsuranceSupportPhone,
})

export default storeConnect({ mapStateToProps })(ReservationConfirmationInfo)
